﻿import { genericSearch, genericSearchOptions, replaceSelectOptions } from './ts/GenericSearch';
function resultBuilder (element: HTMLElement, results: any): void {
   const ddlCountry = document.querySelector<HTMLSelectElement>('#ddlCountry');
   const ddlInstitution = document.querySelector<HTMLSelectElement>('#ddlInstitution');
   const ddlType = document.querySelector<HTMLSelectElement>('#ddlType');
   const ddlDiscipline = document.querySelector<HTMLSelectElement>('#ddlDiscipline');

   replaceSelectOptions(ddlCountry, results.countries, results.country);
   replaceSelectOptions(ddlInstitution, results.institutions, results.institutionId);
   replaceSelectOptions(ddlType, results.infrastructureTypes, results.infrastructureTypeId);
   replaceSelectOptions(ddlDiscipline, results.disciplines, results.disciplineId);

   element.innerHTML = '';
   results.resultList.forEach((value: any, index: number) => {
      let row = document.createElement('tr');
      row.innerHTML = `<td data-search-score="${ value.score }">${ index + 1 }</td><td><a href="${ value.detailsUrl }">${ value.name }</a></td><td><a href="${ value.institutionUrl }" target="_blank" rel="nofollow">${ value.institutionName }</a></td><td>${ value.country }</td><td>${ value.infrastructureType }</td>`;
      element.appendChild(row);
   });
}

const opt: genericSearchOptions = {
   formSelector: '#riSearchForm',
   resultsTableBodySelector: '#search_results_tbody',
   resultsTableSelector: '#search_results',
   messageSelector: '#search_message',
   filterButtonSelector: '#btn_collapse_form',
   formCollapseSelector: '#searchAdvanced',
   queryUrl: '/Umbraco/Api/ResearchInfrastructureApi/Search/',
   resultsBuilder: resultBuilder
}

genericSearch(opt);
